function parseErrorMessage(error: unknown) {
  if (error === undefined || error === null) {
    return undefined
  }

  if (typeof error === 'string') {
    return error
  }

  if (typeof error !== 'object') {
    return String(error)
  }

  if ('message' in error && typeof (error as { message: unknown }).message === 'string') {
    return (error as { message: string }).message
  }

  try {
    return JSON.stringify(error).slice(0, 200)
  } catch {
    return Object.prototype.toString.call(error)
  }
}

// `Error` instances survive `postMessage` structured clone with their message, name and stack;
// anything else is reduced to a string so the payload is always cloneable
export function toCloneableError(error: unknown, fallbackMessage: string): Error | string {
  if (error instanceof Error) {
    return error
  }

  return parseErrorMessage(error) ?? fallbackMessage
}

export function buildWorkerError(error: Error | string, workerName: string): Error {
  const prefix = `Error from worker ${workerName}: `

  if (typeof error === 'string') {
    return new Error(`${prefix}${error}`)
  }

  error.message = `${prefix}${error.message}`
  return error
}
